import ApiService from '../../api/api';
import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export default {
    namespaced: true,
    state() {
        return {
            form: {
                enabled: false,
                connected: false,
                exported: false,
                host: null,
                port: null,
                user: null,
                password: null,
                db: null
            },
        }
    },
    mutations: {
      setForm: (state, value) => {
          window.Vue.set(state, 'form', value);
      }
    },
    actions: {
        getConnection({state, commit, getters}, id) {
            return new Promise((resolve, reject) => {
                ApiService.get('/remote-db/' + id)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        connect({state, commit, getters}, {id, form}) {
            return new Promise((resolve, reject) => {
                ApiService.post('/remote-db/connect/' + id, {form: form})
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        disconnect({state, commit, getters}, {id, form}) {
            return new Promise((resolve, reject) => {
                ApiService.post('/remote-db/disconnect/' + id, {form: form})
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        export({state, commit, getters}, {id, form}) {
            return new Promise((resolve, reject) => {
                ApiService.post('/remote-db/export/' + id, {form: form})
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        resetForm({state, commit}) {
            const properties = {
                enabled: false,
                connected: false,
                exported: false,
            };

            let form = {};

            Object.keys(state.form).forEach((property) => {
                if (properties.hasOwnProperty(property)) {
                    form[property] = properties[property];
                } else {
                    form[property] = null;
                }
            });

            commit('setForm', form);
        }
    }
};


